var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 1.125c0-.391.317-.708.708-.708h10.625c.392 0 .709.317.709.708v9.208a.708.708 0 01-.709.709H1.208a.708.708 0 01-.708-.709V1.125zm1.417.708v7.792h9.208V1.833H1.917z",
    fill: "#007F33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.125 4.667c0-.392.317-.709.708-.709h2.834c.188 0 .368.075.5.208l2.126 2.125a.708.708 0 01.207.5v3.542a.708.708 0 01-.708.709h-4.959a.708.708 0 01-.708-.709V4.667zm1.417.708v4.25h3.541v-2.54l-1.71-1.71h-1.831zM4.396 11.042a1.063 1.063 0 100 2.125 1.063 1.063 0 000-2.125zm-2.48 1.062a2.48 2.48 0 114.959 0 2.48 2.48 0 01-4.958 0z",
    fill: "#007F33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.604 11.042a1.063 1.063 0 100 2.125 1.063 1.063 0 000-2.125zm-2.479 1.062a2.48 2.48 0 114.958 0 2.48 2.48 0 01-4.958 0z",
    fill: "#007F33"
  })));
}
export default SvgDelivery;